import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=6394646f&scoped=true&"
import script from "./WorkingHours.vue?vue&type=script&lang=js&"
export * from "./WorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHours.vue?vue&type=style&index=0&id=6394646f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394646f",
  null
  
)

export default component.exports